import { render } from "./PrivacyPolicy.vue?vue&type=template&id=68964c41&scoped=true&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=68964c41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68964c41"]])

export default __exports__